import { ReactNode } from 'react';

import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import BarraCanaisDesconectados from 'components/BarraCanaisDesconectados';
import Header from 'components/Header';
import NavBar from 'components/NavBar';

import BarraAlertaArmazenamento from './BarraAlertaArmazenamento';
import BarraLoginDeSuporte from './BarraLoginDeSuporte';

type LayoutProps = {
  children: ReactNode;
};

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
  },
  container: {
    flexGrow: 1,
    display: 'flex',
    overflow: 'hidden',
    backgroundColor: palette.background.paper,
  },
  content: {
    flexGrow: 1,
    position: 'relative',
    padding: spacing(2, 2, 0),
    borderTopLeftRadius: spacing(3),
    backgroundColor: palette.background.default,
  },
}));

export default function Layout({ children }: LayoutProps) {
  const classes = useStyles();

  return (
    <Box id="app-layout" className={classes.root}>
      <BarraLoginDeSuporte />
      <BarraAlertaArmazenamento />
      <BarraCanaisDesconectados />

      <Header />
      <Box className={classes.container}>
        <NavBar />
        <Box component="main" className={classes.content}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
